import { query, where, getDocs } from 'firebase/firestore';
import { DayModel, getDateKey } from 'features/day/day-types';
import loadBatch from './api-utils';
import { fsCollection, fsSetDoc } from './firestore-collection';

export const saveDayModel = async (model: DayModel) => {
  try {
    await fsSetDoc('days', model.date, model);
    return model;
  } catch (e) {
    console.error('saveDayModel', e);
    throw e;
  }
};

export const loadDayModels = async (from: Date, to: Date) => {
  try {
    const q = query(
      fsCollection('days'),
      where('date', '>=', getDateKey(from)),
      where('date', '<=', getDateKey(to))
    );
    const data = await getDocs(q);

    return data.docs.map((d) => d.data() as DayModel);
  } catch (e) {
    console.error('loadDayModels', e);
    throw e;
  }
};

const loadDayModelsBatch = async (dateKeys: string[]): Promise<DayModel[]> => {
  const q = query(fsCollection('days'), where('date', 'in', dateKeys));
  const data = await getDocs(q);
  return data.docs.map((d) => d.data() as DayModel);
};

export const loadDayModelsByDate = async (
  dateKeys: string[]
): Promise<DayModel[]> => {
  try {
    return await loadBatch(dateKeys, loadDayModelsBatch);
  } catch (e) {
    console.error('loadDayModels', e);
    throw e;
  }
};
